module.exports = __webpack_public_path__ + "img/4064018300.851f98e6.jpg";